import createReactComponent from '../createReactComponent';
export default createReactComponent('arrows-up-from-line', 'ArrowsUpFromLine', [["path",{"d":"M10 7 7 3 4 7m3-4v14M20 7l-3-4-3 4m3-4v14M4 21h16","key":"svg-0"}]]);